<template>
	<div>
		<div class="head">
			<weitap class="weitap" :shuju="shuju" :Tapchecked="Tapchecked"></weitap>

			<div class="huihright">
				<a class="el-button el-button--primary el-button--middle is-round" :href="baseUrl + 'saas/user/xiaz'" target="_blank" style="background-color:#E6BE8A;border-color:#E6BE8A;padding: 7px 20px; border-radius: 15px; box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 12px 0px; vertical-align: middle;">下载导入模板</a>
				<!--<purBtn msg="下载导入模板" v-on:fn="downtemp" style="vertical-align: middle"></purBtn>-->
				<purBtn msg="导入潜客" style="vertical-align: middle" v-on:fn="fn(1)"></purBtn>
				<!--<purBtn msg="导入潜客月龄" style="vertical-align: middle" v-if="centre_id==569 || centre_id==234 || centre_id == 223" v-on:fn="fn(2)"></purBtn>-->
				<el-select v-model="value" placeholder="请选择" @change="xuan" size="small" style="width: 100px;margin-left: 6px;vertical-align: middle">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<!--<el-select v-model="item_id" placeholder="请选择合约" size="small" style="width: 120px;margin-left: 6px;vertical-align: middle">-->
					<!--<el-option value="">请选择</el-option>-->
					<!--<el-option v-for="item in items" :key="item.id" :label="item.name" :value="item.id"></el-option>-->
				<!--</el-select>-->
				<el-select v-model="type" placeholder="请选择" size="small" style="width: 100px;margin-left: 6px;vertical-align: middle">
					<el-option v-for="item in typeoptions" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<div style="width: 180px;display: inline-block;vertical-align: middle;margin-left: 6px" class="searchbox">
					<el-row style="width: 150px;">
						<el-col :span="24">
							<el-input placeholder="请输入内容" v-model="input5" class="input-with-select" size="small" @keyup.enter.native="search1">
								<el-button slot="append" type="warning" size="small" style="
								background:#E6BE8A;color: #fff;border: 1px solid #E6BE8A;border-bottom:0;border-radius: 0  4px 4px 0"
								icon="el-icon-search" @click="search1"></el-button>
							</el-input>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>

		<div class="tabBox">
			<table class="table table-bordered table-hover table-striped" v-loading="loading2">
				<thead>
					<tr>
						<th>状态</th>
						<th>姓名</th>
						<th>性别</th>
						<th>别名</th>
						<th>出生日期</th>
<!--						<th>合约名称</th>-->
						<th>剩余次数</th>
						<th>合约结束时间</th>
						<th>家长姓名</th>
						<th>联系方式</th>
						<th>操作</th>
					</tr>
				</thead>
				<tbody>
					<el-tooltip placement="Bottom left" v-for="(ta,index) in tabdata" :key="index">
						<div slot="content">多行信息<br />第二行信息</div>
						<tr @click="jump2('huiyuanx',ta.user_id,ta.vip)" style="cursor: pointer">
							<td>{{ta.vip|hui}} </td>
							<td>{{ta.baobao_name}}</td>
							<td>{{ta.baobao_sex}} </td>
							<td>{{ta.baobao_name2}} </td>
							<td>{{ta.baobao_birthday}} </td>
<!--							<td>{{ta.item_name}} </td>-->
							<td>{{ta.y_keshi ? ta.y_keshi : '--'}} </td>
							<td>{{ta.e_time}} </td>
							<td>{{ta.name}} </td>
							<td>{{ta.phone}} </td>
							<td style="color:#E6BE8A">
<!--								 <span class="kedianji" @click.stop="xiu(ta.user_id)">修改</span> |-->
								<span @click.stop="shanchu(ta.user_id,ta.baobao_name)" class="kedianji">删除</span>
							</td>
						</tr>
					</el-tooltip>
					<tr>
						<td v-if="tabdata==''" colspan="11">暂无数据</td>
					</tr>
				</tbody>
			</table>
			<p>共{{zongt}}条记录</p>
		</div>

		<div class="table-bottom">
			<div>
				<el-pagination @current-change="fanye" :page-size="pageong" background :current-page="curpage" layout="prev, pager, next"
				 :total="zongt">
				</el-pagination>
			</div>
		</div>

		<el-dialog class="tanchuang" :visible.sync="dialogVisible2" width="300px">
			<span slot="title" class="dialog-footer">删除会员</span>
			<div>
				确认删除({{tanname}})吗?
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="dialogVisible2 = false">取 消</el-button>
				<el-button size="mini" type="warning" @click="queshan">确 定</el-button>
			</span>
		</el-dialog>

		<form method='post' enctype="multipart/form-data" id="formbox" style="display: none">
			<div style="width: 200px;width:200px;background: red"></div>
			<input type="text" v-model="token" name="token" style="display: none">
			<input type="text" id="txt1" name="type" value="1">
			<input type="file" id="fil" name="ex" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
			 @change="tijiao(1)" style="display: none">
		</form>
		<form method='post' enctype="multipart/form-data" id="formbox2" style="display: none">
			<input type="text" v-model="token" name="token" style="display: none">
			<input type="text" id="txt2" name="type" value="2">
			<input type="file" id="fil2" name="ex" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
			 @change="tijiao(2)" style="display: none">
		</form>


		<el-dialog class="tanchuang" :visible.sync="dialogVisible3" width="300px">
			<span slot="title" class="dialog-footer">导入潜客情况</span>
			<div>
				导入成功{{chengt}}条，导入失败{{shibait}}条，<a :href="xzurl" target="_blank" download="">下载错误日志 </a>
			</div>
			<span slot="footer" class="dialog-footer">

			</span>
		</el-dialog>

	</div>
</template>

<script>
	import purBtn from '@/components/btn.vue'
	import weitap from '@/components/weitap'

	export default {
		components: {
			purBtn,
			weitap,
		},
		data() {
			return {
				dialogVisible2: false,
				dialogVisible3: false,
				loading2: false,
				value:'1',
        shownewcontract:false,
				shuju: [{
						lian: 'huiyuan',
						neir: '会员列表'
					},
					{
						lian: 'insert',
						neir: '新增会员'
					},
					{
						lian: 'add_con',
						neir: '签约'
					},
					// {
					// 	lian: 'tuoyuqianyue',
					// 	neir: '托育签约'
					// },
          // {
          //   lian: 'tuoyuqynew',
          //   neir: '托育签约2'
          // }
				],
				Tapchecked: 0,
				options: [{
					value: '1',
					label: '会员'
				}, {
					value: '0',
					label: '非会员'
				}, {
                    value: '3',
                    label: '无效会员'
                }],
				typeoptions: [{
					value: 'phone',
					label: '联系方式'
				}, {
					value: 'name',
					label: '姓名'
				}, {
					value: 'monthage',
					label: '月龄'
				}, {
					value: 'source',
					label: '来源'
				}
//				, {
//					value: 'class',
//					label: '课时'
//				}
				],
				input5: '',
				pageong: 15,
				curpage: 1,
				zongt: 0,
				tabdata: '',
				tanname: '',
				tanid: '',
				token: '',
				chengt: '',
				shibait: '',
				file1: '',
				xzurl: '',
				centre_id: '',
				type: 'name',
				zhi2: '',
				filobj: '',
				items:[],//项目
				item_id:'',
				baseUrl: ''
			}
		},
		created() {
			this.baseUrl = process.env.apiUrl
		},
		methods: {
		    checkshuju(){
		        let that = this;
		        if(that.centre_id == 117){
		            that.shuju = [{
                        lian: 'huiyuan',
                        neir: '会员列表'
                    },
                        {
                            lian: 'insert',
                            neir: '新增会员'
                        },
                        {
                            lian: 'huiyuanqianxin',
                            neir: '早教签约'
                        },
                        {
                            lian: 'tuoyuqianyue',
                            neir: '托育签约'
                        }
                    ]
                }else{
                    that.shuju = [{
                        lian: 'huiyuan',
                        neir: '会员列表'
                    },
                        {
                            lian: 'insert',
                            neir: '新增会员'
                        },
                        {
                            lian: 'huiyuanqianxin',
                            neir: '早教签约'
                        },
                        {
                            lian: 'tuoyuqianyue2',
                            neir: '托育签约'
                        }
                    ]
                }
            },
			jump: function(d) {
				this.$router.push(d)
			},
			//下载导入模板
			downtemp() {
				let self = this;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + "saas/user/xiaz",
					async: false,
					data: {
						token: self.token,
						user_id: self.tanid
					},
					success: function(data) {
						window.open(data, '_blank').location;
					},
					error: function(data) {
						self.$message.error(`请求失败`);
					}
				});
			},
			jump2: function(d, id, v) {
				this.$router.push({
					name: d,
					query: {
						id: id,
						vip: v
					}
				})

			},
			tijiao: function(type) {
				const loading = this.$loading({
					lock: true,
					text: '导入中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				let formData = "";
				if (type == 1) {
					formData = new FormData($('#formbox')[0]);
				} else {
					formData = new FormData($('#formbox2')[0]);
				}
				let self = this;
				$.ajax({
					type: "POST",
					url: process.env.apiUrl + "saas/User/uploadFile",
					data: formData,
					contentType: false,
					processData: false,
					dataType: 'json',
					success: function(data) {
						loading.close();
						if (data.status == 3) {
							self.$message.success(`导入潜客成功!导入成功${data.success}条，导入失败${data.err}条`)
						} else if (data.status == 4) {
							self.chengt = data.success;
							self.shibait = data.err;
							self.xzurl = data.xzurl;
							self.dialogVisible3 = true;
							self.file1 = data.file;
						} else if (data.status == 5) {
							self.$message.error(`未选择文件`)
						}
						if (type == 1) {
							$('#fil').remove()
							$('#txt1').after(self.filobj)
							$('#fil').change(function() {
								self.tijiao(1)
							})
						} else {
							$('#fil2').remove()
							$('#txt2').after(self.filobj)
							$('#fil2').change(function() {
								self.tijiao(2)
							})
						}
					},
					error: function() {
						loading.close();
						self.$message.error(`上传失败，请检查网络后重试`)
					}
				});
			},
			fn: function(type) {
				if (type == 1) {
					this.filobj = $('#fil').clone()
					$('#fil').get(0).click()
				} else {
					this.filobj = $('#fi2').clone()
					$('#fil2').get(0).click()
				}
			},
			xuan: function() {
				let self = this;
				self.curpage = 1;
				self.gonggong()
			},
			search1: function() {
				let self = this;
				self.curpage = 1;
				self.gonggong()
			},
			gonggong: function() {
				let self = this;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + "saas/User/user",
					data: {
						token: self.token,
						zhi: self.input5,
						p: self.curpage,
						status: self.value,
						type: self.type,
						item_id: self.item_id
					},
					beforeSend: function(xhr) {
						self.loading2 = true
					},
					success: function(data) {
						self.loading2 = false
						self.zongt = Number(data.zong.num);
						self.tabdata = data.fen;
						self.pageong = Number(data.zong.pageone);
					},
					error: function(data) {
						self.dialogVisible2 = false;
						self.$message.error(`请求失败!`);
					}
				});
			},
			fanye: function(i) {
				let self = this;
				self.curpage = i;
				self.gonggong()
			},
			xiu: function(d) {
				this.$router.push({
					name: 'huiyuanxiu',
					query: {
						id: d
					}
				})
			},
			shanchu: function(id, name) {
				let self = this;
				self.dialogVisible2 = true;
				self.tanid = id;
				self.tanname = name;

			},
			queshan: function() {
				let self = this;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + "saas/User/shanchu",
					data: {
						token: self.token,
						user_id: self.tanid
					},
					beforeSend: function(xhr) {
						self.loading2 = true
					},
					success: function(data) {
						if (data == 1) {
							self.gonggong();
							self.dialogVisible2 = false;
						} else {
							self.dialogVisible2 = false;
							self.$message.success('删除失败，请稍后重试！');
						}
					},
					error: function(data) {
						self.dialogVisible2 = false;
						self.$message.error(`请求失败`);
					}
				});
			},
			//选择项目
			get_item(){
				let self = this;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + "saas/biao/item_type",
					data: {
						token: self.token,
					},
					success: function(res) {
						if (res.status == 1) {
							self.items = res.data
						}
					},
					error: function(data) {
						self.$message.error(`请求失败`);
					}
				});
			},
		},
		filters: {
			hui: function(arg) {
				if (arg == 0) {
					return '非会员'
				} else if (arg == 1 || arg == 2) {
					return '会员'
				}
			},
		},
		mounted: function() {
			let self = this;
			self.token = self.$cookies.get('token');

			$.ajax({
				type: 'POST',
				url: process.env.apiUrl + "saas/User/user",
				data: {
					token: self.token
				},
				success: function(data) {
					self.centre_id = data.centre_id;
					self.zongt = Number(data.zong.num);
					self.pageong = Number(data.zong.pageone);
					self.tabdata = data.fen;
				},
				error: function() {
					self.$message.error(`请求失败`);
				}
			});
			// self.checkshuju()
			self.get_item()
		}

	}
</script>

<style scoped>
	* {
		font-size: 14px;
	}

	.tabBox {
		padding-left: 45px;
		padding-right: 45px;
		padding-top: 10px;
		padding-bottom: 15px;
	}

	.head {
		padding: 10px 45px 0;
		display: flex;
		display: -webkit-flex;
		justify-content: space-between;
		flex-wrap: nowrap;
		border-bottom: 1px solid #bdb8e0;
	}

	.table-bottom {
		display: flex;
		display: -webkit-flex;
		justify-content: center;
	}

	.kedianji {
		color: #E6BE8A;
		cursor: pointer;
	}
	.huihright {
		min-width: 918px;
	}
	.weitap {
		flex-shrink: 1;
		min-width: 300px!important;
		margin-right: 10px!important;
	}
</style>
<style>
	.head .el-input__inner {
		border-radius: 15px;
		border: 1px solid #E6BE8A;
	}

	.searchbox .el-input__inner {
		border-radius: 15px 0 0 15px;
	}

	.huihright .el-input-group__append {
		border-radius: 0 15px 15px 0;
		overflow: hidden;
		border: 1px solid #E6BE8A;

	}

	#sbox {
		border-radius: 15px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/huiyuan/huiyuan.vue